import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../hooks/useIsMobile"; // ← notre hook

export default function About() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  // on construit un tableau pour éviter de répéter le code
  const items = [
    {
      key: "about.left",
      title: t("about.left.title"),
      text: t("about.left.text"),
    },
    {
      key: "about.right",
      title: t("about.right.title"),
      text: t("about.right.text"),
    },
  ];

  return (
    <div className="About">
      <h2>{t("about.title")}</h2>
      <ul>
        {items.map(({ key, title, text }) => (
          <li key={key}>
            {isMobile ? (
              <details className="accordion">
                <summary>{title}</summary>
                <p>{text}</p>
              </details>
            ) : (
              <>
                <h3>{title}</h3>
                <p>{text}</p>
              </>
            )}
          </li>
        ))}
      </ul>
      <Link to="/about" className="button">
        {t("about.button")}
      </Link>
    </div>
  );
}
